import React from 'react';
const IconCommentAdd = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M20 2C21.1 2 22 2.9 22 4V22L18 18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20ZM13 11H17V9H13V5H11V9H7V11H11V15H13V11Z" fill="#666666"/>
</svg>
);
};
export default IconCommentAdd;